export default __webpack_public_path__ + "static/amazon_logo_RGB_WHITE-9dac82cfe74be7775893d8c4893739fd.png";